import { useTranslation } from "react-i18next";
import { labelFor } from "../services/enumLabels";

const TONES = {
  male: "bg-info-wash text-info-text",
  female: "bg-danger-wash text-danger-text",
  both: "bg-accent-wash text-accent-text",
};

/** male | female | both, or null for a legacy branch with none yet. */
export default function GenderBadge({ gender }) {
  const { t } = useTranslation();

  return (
    <span
      className={`whitespace-nowrap rounded-full px-2 py-1 text-xs ${TONES[gender] ?? "bg-raised text-ink-2"}`}
    >
      {gender ? labelFor("gender", gender) : t("genders.notSet")}
    </span>
  );
}
